export const loadingSpinner = {
  spinner: 'loading-spinner',
};
